import { useNavigate, useLocation, useParams } from 'react-router-dom'

export function NotFoundPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { tenantSlug } = useParams<{ tenantSlug: string }>()

  const isEngineerRoute = location.pathname.includes('/engineer')
  const homePath = tenantSlug
    ? isEngineerRoute ? `/${tenantSlug}/engineer` : `/${tenantSlug}/dashboard`
    : '/'

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-50 p-8">
      <div className="text-center">
        <p className="text-8xl font-bold" style={{ color: 'var(--brand-primary, #111827)' }}>
          404
        </p>
        <h2 className="mt-4 text-xl font-semibold text-gray-900">
          Page not found
        </h2>
        <p className="mt-2 text-sm text-gray-500">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button
          onClick={() => navigate(homePath)}
          className="mt-8 inline-block px-5 py-2.5 text-sm font-medium text-white rounded-lg transition-colors"
          style={{
            backgroundColor: 'var(--brand-primary, #111827)',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.9' }}
          onMouseLeave={(e) => { e.currentTarget.style.opacity = '1' }}
        >
          Go to home
        </button>
      </div>
    </div>
  )
}
